import { Get } from "../../../api/apiHelper";
import UserAccountModel from "../models/user-account-model";

const userRoot = "/api/users";

async function getAccount(): Promise<UserAccountModel> {
  const response = await Get(`${userRoot}/account`);
  return response.data as UserAccountModel;
}

export default getAccount;
